module.exports = __webpack_public_path__ + "static/img/隋准A.fb3aa576.png";